(function () {
  var sectionSelector = '[data-hpn-real-results-reviews]';
  var trackSelector = '[data-hpn-real-results-track]';
  var arrowsSelector = '[data-hpn-real-results-arrows]';
  var prevSelector = '[data-hpn-real-results-prev]';
  var nextSelector = '[data-hpn-real-results-next]';
  var paginationSelector = '[data-hpn-real-results-pagination]';
  var paginationButtonClass = 'hpn-real-results-reviews__pagination-button';
  var scrollTolerance = 3;

  function getCards(track) {
    return Array.prototype.slice.call(track.children).filter(function (child) {
      return child.classList.contains('hpn-real-results-reviews__card');
    });
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getViewport(section) {
    return section.querySelector('.hpn-real-results-reviews__viewport');
  }

  function getMaxOffset(track, viewport) {
    if (!track || !viewport) {
      return 0;
    }

    return Math.max(0, track.scrollWidth - viewport.clientWidth);
  }

  function dedupePositions(positions) {
    return positions.reduce(function (uniquePositions, position) {
      var roundedPosition = Math.round(position);
      var previousPosition = uniquePositions[uniquePositions.length - 1];

      if (typeof previousPosition === 'undefined' || Math.abs(roundedPosition - previousPosition) > scrollTolerance) {
        uniquePositions.push(roundedPosition);
      }

      return uniquePositions;
    }, []);
  }

  function getPagePositions(section) {
    var viewport = getViewport(section);
    var track = section.querySelector(trackSelector);
    var cards = track ? getCards(track) : [];
    var maxOffset = getMaxOffset(track, viewport);

    if (!viewport || !track || cards.length < 2 || maxOffset <= scrollTolerance) {
      return [0];
    }

    var positions = [0];

    cards.forEach(function (card) {
      positions.push(clamp(card.offsetLeft, 0, maxOffset));
    });

    positions.push(maxOffset);

    positions = positions.sort(function (a, b) {
      return a - b;
    });

    return dedupePositions(positions);
  }

  function getState(section) {
    if (!section.hpnRealResultsReviewsState) {
      section.hpnRealResultsReviewsState = {
        activeIndex: 0,
        pages: [0]
      };
    }

    return section.hpnRealResultsReviewsState;
  }

  function renderPagination(section, pagination, pages) {
    var currentPageCount = Number(pagination.dataset.pageCount || 0);

    if (currentPageCount === pages.length) {
      return;
    }

    pagination.dataset.pageCount = String(pages.length);
    pagination.innerHTML = '';

    pages.forEach(function (_pagePosition, index) {
      var button = document.createElement('button');

      button.type = 'button';
      button.className = paginationButtonClass;
      button.setAttribute('aria-label', 'Show review slide ' + (index + 1));

      button.addEventListener('click', function () {
        goToPage(section, index);
      });

      pagination.appendChild(button);
    });
  }

  function updatePaginationState(pagination, activeIndex) {
    var buttons = Array.prototype.slice.call(pagination.children);

    buttons.forEach(function (button, index) {
      if (index === activeIndex) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function applyCarouselState(section) {
    var track = section.querySelector(trackSelector);
    var arrows = section.querySelector(arrowsSelector);
    var prevButton = section.querySelector(prevSelector);
    var nextButton = section.querySelector(nextSelector);
    var pagination = section.querySelector(paginationSelector);
    var state = getState(section);
    var pages = getPagePositions(section);
    var shouldShowControls = pages.length > 1;

    if (!track || !arrows || !prevButton || !nextButton || !pagination) {
      return;
    }

    state.pages = pages;
    state.activeIndex = clamp(state.activeIndex, 0, pages.length - 1);

    arrows.hidden = !shouldShowControls;
    pagination.hidden = !shouldShowControls;

    if (!shouldShowControls) {
      pagination.dataset.pageCount = '0';
      pagination.innerHTML = '';
      prevButton.disabled = true;
      nextButton.disabled = true;
      track.style.transform = '';
      return;
    }

    renderPagination(section, pagination, pages);

    track.style.transform = 'translate3d(-' + pages[state.activeIndex] + 'px, 0, 0)';

    updatePaginationState(pagination, state.activeIndex);

    prevButton.disabled = state.activeIndex === 0;
    nextButton.disabled = state.activeIndex === pages.length - 1;
  }

  function goToPage(section, index) {
    var state = getState(section);

    state.pages = getPagePositions(section);
    state.activeIndex = clamp(index, 0, state.pages.length - 1);

    applyCarouselState(section);
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    var track = section.querySelector(trackSelector);
    var prevButton = section.querySelector(prevSelector);
    var nextButton = section.querySelector(nextSelector);

    if (!track || !prevButton || !nextButton) {
      return;
    }

    if (section.dataset.hpnRealResultsReviewsInitialized === 'true') {
      applyCarouselState(section);
      return;
    }

    section.dataset.hpnRealResultsReviewsInitialized = 'true';

    prevButton.addEventListener('click', function () {
      var state = getState(section);

      goToPage(section, state.activeIndex - 1);
    });

    nextButton.addEventListener('click', function () {
      var state = getState(section);

      goToPage(section, state.activeIndex + 1);
    });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(function () {
        applyCarouselState(section);
      });
    });

    applyCarouselState(section);
  }

  function initAll() {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches(sectionSelector)) {
      initSection(event.target);
      return;
    }

    initSection(event.target.querySelector(sectionSelector));
  });
})();